/**
 * Centralized frontend config.
 *
 * CRA only exposes env vars prefixed with `REACT_APP_`.
 * Changes require restarting the dev server.
 */
const configuredApiBaseUrl = process.env.REACT_APP_API_URL?.trim();
export const API_BASE_URL: string = configuredApiBaseUrl ||
  (process.env.NODE_ENV === 'production'
    ? (typeof window !== 'undefined' ? window.location.origin : '')
    : 'http://localhost:3001');

export const AGENT_COLLABORATION_BASE_URL: string = `${API_BASE_URL}/agent`;

export const DISCORD_COMMUNITY_URL: string =
  process.env.REACT_APP_DISCORD_COMMUNITY_URL?.trim() ||
  'https://discord.gg/3DAB8WjKUq';

export const GOOGLE_ANALYTICS_MEASUREMENT_ID: string =
  process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID?.trim() || '';

const analyticsEnabledOverride = process.env.REACT_APP_GOOGLE_ANALYTICS_ENABLED?.trim().toLowerCase();
export const GOOGLE_ANALYTICS_ENABLED: boolean = analyticsEnabledOverride
  ? ['1', 'true', 'yes', 'on'].includes(analyticsEnabledOverride)
  : process.env.NODE_ENV === 'production';

export const DEFAULT_GEMINI_MODEL: string = 'gemini-3-pro-preview';

// The Generative Studio page and its navigation item. Switched off for now, not removed: generation
// stays in the editor's Generate and the Agent. Flip back to true to restore the page.
export const STUDIO_ENABLED: boolean = false;

// Social publishing on public pages. Which platforms each account can use comes from the backend.
export const SOCIAL_PUBLISHING_LAUNCHED: boolean = true;
// Instagram mentions and /schedule-social-videos, which promises Instagram, stay hidden until Meta approves the app.
// To launch, flip this, make /schedule-social-videos indexable in seo/siteMetadata.json and add instagram to
// SOCIAL_PUBLISHING_PLATFORMS on the backend.
export const INSTAGRAM_PUBLISHING_LAUNCHED: boolean = false;
// TikTok posting claims on public pages stay hidden until TikTok audits Direct Post (unaudited apps can only post to
// private accounts). To launch, flip this and add tiktok to SOCIAL_PUBLISHING_PLATFORMS on the backend.
export const TIKTOK_PUBLISHING_LAUNCHED: boolean = false;
// Twitch imports and the Twitch mentions on public pages, including /twitch-to-tiktok. To launch, flip this,
// make /twitch-to-tiktok indexable in seo/siteMetadata.json and set TWITCH_IMPORTS_ENABLED on the backend.
export const TWITCH_IMPORTS_LAUNCHED: boolean = false;

const DEFAULT_ADMIN_HOSTNAMES = [
  'www.admin.imabird.productions',
  'admin.imabird.productions',
];

export const ADMIN_HOSTNAMES: string[] = (
  process.env.REACT_APP_ADMIN_HOSTNAMES?.split(/[,\s]+/) || DEFAULT_ADMIN_HOSTNAMES
)
  .map((host) => host.trim().toLowerCase())
  .filter(Boolean);

export const isAdminHost = (hostname: string = window.location.hostname): boolean =>
  ADMIN_HOSTNAMES.includes(hostname.trim().toLowerCase());

const DEFAULT_SOCIAL_HOSTNAMES = ['social.imabird.productions'];

export const SOCIAL_HOSTNAMES: string[] = (
  process.env.REACT_APP_SOCIAL_HOSTNAMES?.split(/[,\s]+/) || DEFAULT_SOCIAL_HOSTNAMES
)
  .map((host) => host.trim().toLowerCase())
  .filter(Boolean);

export const isSocialHost = (hostname: string = window.location.hostname): boolean =>
  SOCIAL_HOSTNAMES.includes(hostname.trim().toLowerCase());
